export const steps = Object.freeze({
	product: 'Item',
	pricing: 'Preços e Disponibilidade'
});

export const stepsKeys = Object.freeze({
	product: 'product',
	pricing: 'pricing'
});
